<script>
    import './leafletMap.scss';
    import { onMount } from 'svelte';
    import { createMap } from './map-utils.js';

    export let geoJsonData;
    export let pageURL;
    export let apiURL;
    export let ambiti;
    export let placeDetailPageURL;

    let mapId = 'map_'+Math.random().toString();

    onMount(() => {
        createMap(mapId, geoJsonData, pageURL, apiURL, ambiti, placeDetailPageURL);
    });
</script>

<div id="{mapId}" class="leafletMap"></div>
